module.exports = __webpack_public_path__ + "img/terms_and_conditions_border.7d861a89.svg";